export enum DocTypeOpenText {
    Plico = 'PLICO',
    LetteraAccettazione = 'LETTERA_ACCETTAZIONE',
    LetteraDiniego = 'LETTERA_DINIEGO',
    LetteraRecessoTimoe = 'LETTERA_RECESSO_TIMOE',
    ModuloSepa = 'MODULO_SEPA',
    VariazioniTecniche = 'VARIAZIONI_TECNICHE_SUP',
}
